'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('login', {
            url: '/login',
            templateUrl: 'login/login.html',
            controller: 'loginCtrl as ctrl'
        });
};
